import { programRequestsApi } from '../api/programRequestsApi';
import { toCreateMergeRequest } from './mergeProgramsModel';

export const createMergeProgramsFlow = async ({
    form,
    onError,
    api = programRequestsApi,
}) => Boolean(await api.createMergeRequest(toCreateMergeRequest(form), onError));
